// components
import { Navbar, Footer } from "@/components";
import { RegisterSection } from "@/components/register-form";

export default function RegisterPage() {
  return (
    <>
      <Navbar />
      <RegisterSection />
      <Footer />
    </>
  );
}

